<script>
import { http } from '@/plugins/http';
import { mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';
import VSelect from '@/components/Common/VSelect';

const initFormData = () => ({
  phone: null,
  name: null,
  brand: null,
  model: null,
});

export default {
  props: {
    brands: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    VInput,
    VSelect,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      form: initFormData(),
      models: [],
    };
  },

  setup() {
    const schema = Yup.object().shape({
      phone: Yup.string().required(),
      name: Yup.string().required(),
      brands: Yup.mixed().nullable(false).required(),
      models: Yup.mixed().nullable(false).required(),
    });

    return {
      schema,
    };
  },

  computed: {
    formData() {
      return {
        name: this.form.name,
        phone: this.form.phone,
        brand: this.form.brand.name,
        model: this.form.model.name,
        action: 'buy-cars-good-price',
      };
    },
  },

  watch: {
    'form.brand'(value) {
      if (value) {
        this.setModels();
      }
    },
  },

  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),

    onSubmit(value, actions) {
      this.send(this.formData);
      this.togglePopup('popup-message');

      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.form = initFormData();
    },
    setModels() {
      return http
        .post('/fleet/models/', {brand: this.form.brand.id})
        .then(data => {
          this.models = data.data;
        })
        .catch(error => {
          return Promise.reject({
            error,
          });
        });
    },
  },
};
</script>

<template>
  <div>
    <vee-form
      :validation-schema="schema"
      novalidate
      class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6 mb-6"
      @submit="onSubmit"
    >
      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="phone"
      >
        <v-input
          v-model="form.phone"
          placeholder="+7 (___) ___-__-__"
          theme="white"
          format="phone"
          inscription="Ваш телефон*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="name"
      >
        <v-input
          v-model="form.name"
          placeholder="Введите ФИО"
          inscription="Контактное лицо"
          format="name"
          name="name"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="brands"
      >
        <v-select
          v-model="form.brand"
          :options="brands"
          inscription="Марка*"
          placeholder="Выберите марку*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>

      <vee-field
        v-slot="{ handleChange, errorMessage }"
        name="models"
      >
        <v-select
          v-model="form.model"
          :options="models"
          inscription="Модель*"
          theme="white"
          placeholder="Выберите модель*"
          :error="errorMessage"
          @update:modelValue="handleChange"
        />
      </vee-field>
      <button
        type="submit"
        class="col-auto button button_green button_big w-full"
      >
        Подать заявку
      </button>
    </vee-form>

    <div class="text-center">
      Я даю согласие группе компаний «Прагматика» на
      <a
        href="/agreement/"
        target="_blank"
        class="text-green hover:underline transition ease-in-out duration-200"
      >обработку моих персональных данных.</a>
    </div>
  </div>
</template>

<style></style>
